export const termsAndConditionsTradeTermsHeader = $localize`:documents|Documents@@termsAndConditionsTradeTermsHeader:Trade terms`;
export const termsAndConditionsUserTermsHeader = $localize`:documents|Documents@@termsAndConditionsUserTermsHeader:User agreement`;
